import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ContactStatsWidget = ({ 
  totalContacts = 0,
  birthdaysThisMonth = 0,
  messagesSent = 0,
  onStatClick = () => {}
}) => {
  const navigate = useNavigate();

  const stats = [
    {
      id: 'total-contacts',
      title: 'Total Contacts',
      value: totalContacts,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+12%',
      changeType: 'positive',
      onClick: () => {
        onStatClick('contacts');
        navigate('/contact-list');
      }
    },
    {
      id: 'birthdays-month',
      title: 'Birthdays This Month',
      value: birthdaysThisMonth,
      icon: 'Calendar',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: '+3',
      changeType: 'positive',
      onClick: () => {
        onStatClick('birthdays');
        navigate('/birthday-calendar');
      }
    },
    {
      id: 'messages-sent',
      title: 'Messages Sent',
      value: messagesSent,
      icon: 'Send',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+24%',
      changeType: 'positive',
      onClick: () => {
        onStatClick('messages');
        navigate('/message-history');
      }
    }
  ];

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'K';
    }
    return num?.toString();
  };

  return (
    <div className="bg-surface rounded-lg border border-border shadow-card p-4 lg:p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="BarChart3" size={20} className="text-primary" />
        <h2 className="text-lg font-semibold text-text-primary">Statistics</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {stats?.map((stat) => (
          <button
            key={stat?.id}
            onClick={stat?.onClick}
            className="p-4 rounded-lg border border-border bg-background hover:bg-muted transition-micro hover-lift text-left group"
          >
            <div className="flex items-center justify-between mb-3">
              <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center group-hover:scale-105 transition-micro`}>
                <Icon name={stat?.icon} size={20} className={stat?.color} />
              </div>
              <div className={`text-xs px-2 py-1 rounded-full ${
                stat?.changeType === 'positive' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}>
                {stat?.change}
              </div>
            </div>

            <div className="space-y-1">
              <div className="text-2xl font-bold text-text-primary group-hover:text-primary transition-micro">
                {formatNumber(stat?.value)}
              </div>
              <div className="text-sm text-text-secondary">
                {stat?.title}
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-3 w-full bg-border rounded-full h-1.5">
              <div 
                className={`h-1.5 rounded-full transition-all duration-500 ${
                  stat?.color?.replace('text-', 'bg-')
                }`}
                style={{ 
                  width: `${Math.min((stat?.value / Math.max(totalContacts, birthdaysThisMonth, messagesSent)) * 100, 100)}%` 
                }}
              />
            </div>
          </button>
        ))}
      </div>
      {/* Summary Section */}
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium text-text-primary">This Month</h3>
            <p className="text-sm text-text-secondary">
              {birthdaysThisMonth} birthdays • {messagesSent} messages sent
            </p>
          </div>
          <div className="text-right">
            <div className="text-lg font-semibold text-success">
              +{Math.round(((messagesSent + birthdaysThisMonth) / Math.max(totalContacts, 1)) * 100)}%
            </div>
            <div className="text-xs text-text-secondary">
              Engagement Rate
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactStatsWidget;